import { Component, OnInit } from '@angular/core'
import { UntypedFormControl } from '@angular/forms'
import { Router } from '@angular/router'
import { Practice, SamlLoginRespose } from '../../../api/models'
import {
    AppSettingService,
    AuthService,
    RolesService,
    SsoService,
    UserPracticesService,
} from '../../../api/services'
import {
    CareFinitySession,
    SessionUser,
} from '../../services/CareFinitySession'
import { AuthGuard } from '../../services/auth-guard'
import { environment } from '../../../../environments/environment'
import { SelectedPatientService } from '../patient/patient-list/patient-service'

@Component({
    selector: 'app-select-practice',
    templateUrl: './select-practice.component.html',
    styleUrls: ['./select-practice.component.css'],
})
export class SelectPracticeComponent implements OnInit {
    displayLoginDialog: boolean
    practices: Array<Practice>
    practiceControl: UntypedFormControl
    private samlLoginRespose: SamlLoginRespose
    private samlLogin: boolean
    displaypopup: boolean = false
    practiceMessage: string
    showPracticeMessage: boolean
    version: string = '5.0.0';
    constructor(
        private router: Router,
        private userPracticesService: UserPracticesService,
        private appSetting: AppSettingService,
        private _guard: AuthGuard,
        private rolesService: RolesService,
        private authService: AuthService,
        private ssoService: SsoService,
        private selectedPatientService: SelectedPatientService,
    ) {
        this.practiceControl = new UntypedFormControl('')
        console.log('state is ', this.router.getCurrentNavigation()?.extras.state)
        this.samlLoginRespose = history.state?.data?.context
        this.samlLogin = history.state?.data?.samlLogin


    }

    ngOnInit() {
        this.version = environment.version;
        this.displaypopup = true
        this.loadPractices()
    }

    loadPractices() {
        this.practices = JSON.parse(localStorage.getItem('user_practices'))
        if (this.practices.length == 1 && CareFinitySession.user.userID != -100) {
            this.displayLoginDialog = false

            localStorage.setItem('PracticeId', this.practices[0].practiceid)
            this.navigateToDashboard(this.practices[0].practiceid)

            return
        } else if (
            this.practices.length > 0 &&
            CareFinitySession.user.userID == -100
        ) {
            localStorage.setItem('PracticeId', this.practices[0].practiceid)
            //this.router.navigate(["administration", "user-list"]);
            this.navigateToUserListForSuperAdmin(this.practices[0].practiceid)

            return
        }
        this.practiceControl.patchValue(this.practices[0].practiceid)
        this.displayLoginDialog = true
    }

    onPracticeSelected(): void {
        this.navigateToDashboard(this.practiceControl.value)
    }

    navigateToDashboard(practiceId: string, skipPracticeMessageCheck = false) {
        if (!practiceId) {
            practiceId = this.practices[0].practiceid
        }
        // Remove a class from body
        document.body.classList.remove('p-overflow-hidden');

        // Remove a specific style from body
        document.body.style.removeProperty('--scrollbar-width: 0px;');

        // Or remove all inline styles from body
        document.body.removeAttribute('style');
        this.userPracticesService
            .userPracticesFetchSettings({ practiceId: practiceId })
            .subscribe((data) => {
                    this.appSetting.appSettingGetPracticeSettings$Response().subscribe({
                        next: (settings) => {
                            const roles = CareFinitySession.user.roles;
                            var ps = settings.body
                            CareFinitySession.selectPractice(data[0], ps)
/*                            CareFinitySession.setUserRole(roles);
*/                               

                            if (this.samlLogin) {

                                // If we have patientContext the go ahead and set it

                                if (this.samlLoginRespose?.patientContext) {
                                   sessionStorage.setItem('ptId', this.samlLoginRespose?.patientContext.patientId);
                                    sessionStorage.setItem('ptName', this.samlLoginRespose?.patientContext.fullName);
                                    this.selectedPatientService.changePatient(this.samlLoginRespose?.patientContext);
                                    this.router.navigate(['Patient', 'dashboard'])
                                }

                                else {
                                    // If we don't have patientContext then pass the response back and get the patient record based on response
                                    this.ssoService.ssoSetPatientContext$Response({ body: this.samlLoginRespose }).subscribe({
                                        next: (r) => {
                                            let pat = r?.body;
                                            if (pat?.patientId) {
                                               sessionStorage.setItem('ptId', pat?.patientId);
                                                sessionStorage.setItem('ptName', pat?.fullName);
                                                this.selectedPatientService.changePatient(pat);
                                                this.router.navigate(['Patient', 'dashboard'])
                                            } else {
                                                this.router.navigate(['patient', 'patient-search'])
                                            }
                                        }
                                        , error: (err) => {
                                            console.log("Unable to get patient conext");
                                            console.error(err)
                                            this.router.navigate(['patient', 'patient-search'])
                                        }
                                    });
                                }
                                return
                            }

                            if (skipPracticeMessageCheck) {

                                if (ps.isArchiveInstance && roles?.appointment) {
                                    if (roles?.patientSearch) {
                                        this.router.navigate(['patient', 'patient-search'])
                                        localStorage.setItem("homeurl", 'patient/patient-search')



                                    } else {
                                        // alert("isArchiveInstance3");
                                        // this.router.navigate(["appointment", "list"]);
                                    }
                                }

                                else {
                                    if (roles?.appointment &&  ps.showAppointment ) {
                                        this.router.navigate(['appointment', 'list'])
                                        localStorage.setItem("homeurl", 'appointment/list')


                                    } else if (roles?.patientSearch) {
                                        this.router.navigate(['patient', 'patient-search'])
                                        localStorage.setItem("homeurl", 'patient/patient-search')



                                    } else {
                                        this.router.navigate(['patient', 'patient-search'])
                                        localStorage.setItem("homeurl", 'patient/patient-search')

                                    }
                                }


                            }


                            if (ps.showPracticeMessagePopUp && !skipPracticeMessageCheck) {
                                this.practiceMessage = data[0].message
                                this.showPracticeMessage = true
                                return
                            }

                            if (ps.isArchiveInstance && roles?.appointment) {
                                if (roles?.patientSearch) {
                                    this.router.navigate(['patient', 'patient-search'])
                                    localStorage.setItem("homeurl", 'patient/patient-search')



                                } else {
                                    // alert("isArchiveInstance3");
                                    // this.router.navigate(["appointment", "list"]);
                                }
                            }

                            else {
                                if (roles?.appointment && ps.showAppointment) {
                                    this.router.navigate(['appointment', 'list'])
                                    localStorage.setItem("homeurl", 'appointment/list')


                                } else if (roles?.patientSearch) {
                                    this.router.navigate(['patient', 'patient-search'])
                                    localStorage.setItem("homeurl", 'patient/patient-search')



                                } else {
                                    this.router.navigate(['patient', 'patient-search'])
                                    localStorage.setItem("homeurl", 'patient/patient-search')





                                }
                            }
                        },
                        error: (err) => {
                            console.error(err)
                        },
                    })
            }, err => {

                console.log(err)
                //CareFinitySession.logout(this.authService)
                //this.router.navigate(['/login'])
            })
    }

    navigateToUserListForSuperAdmin(
        practiceId: string,
        skipPracticeMessageCheck = false,
    ) {
        if (!practiceId) {
            practiceId = this.practices[0].practiceid
        }

        this.userPracticesService
            .userPracticesFetchSettings({ practiceId: practiceId })
            .subscribe((data) => {
                this.appSetting.appSettingGetPracticeSettings$Response().subscribe({
                    next: (settings) => {
                        var ps = settings.body
                        CareFinitySession.selectPractice(data[0], ps)

                        this.router.navigate(['administration', 'user-list'])
                        localStorage.setItem("homeurl", 'administration/user-list')
                    },
                    error: (err) => {
                        console.error(err)
                    },
                })
            }, err => {

                console.log(err)
                //CareFinitySession.logout(this.authService)
                //this.router.navigate(['/login'])
            })
    }
}
